import { useContext, useEffect, useMemo } from "react";
import AuthContext from "../context/AuthContext";
import { ClientProps } from "../interfaces/interfaces";

export const useAssignedClientSelection = () => {
  const {
    clientId,
    clients,
    selectedClientId,
    setSelectedClientId,
  } = useContext(AuthContext);

  const clientOptions = useMemo<ClientProps[]>(
    () =>
      clients.length
        ? clients
        : clientId
          ? [{ id: clientId, name: "Client" }]
          : [],
    [clientId, clients],
  );

  useEffect(() => {
    if (!selectedClientId && clientOptions.length === 1) {
      setSelectedClientId(clientOptions[0].id);
    }
  }, [clientOptions, selectedClientId, setSelectedClientId]);

  return {
    clientOptions,
    selectedClientId: selectedClientId ?? clientOptions[0]?.id ?? null,
    setSelectedClientId,
    showClientFilter: clientOptions.length > 1,
  };
};
